export default __webpack_public_path__ + "static/media/product-1.0e528f12.jpg";